import { toServerDateTimeFormat, toServerFilterDate } from '@shiftnex/framework/src/libs/dayjs';
import dayjs from 'dayjs';

import duration from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetweenPlugin from 'dayjs/plugin/isBetween';
import updateLocale from 'dayjs/plugin/updateLocale';
import relativeTime from 'dayjs/plugin/relativeTime';
import objectSupport from 'dayjs/plugin/objectSupport';

export function initDayJsPlugins() {
  dayjs.extend(duration);
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(objectSupport);
  dayjs.extend(toServerDateTimeFormat);
  dayjs.extend(toServerFilterDate);
  dayjs.extend(customParseFormat);
  dayjs.extend(isBetweenPlugin);
  dayjs.extend(updateLocale);
  dayjs.extend(relativeTime);
}
